import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Img from "gatsby-image"
import useBrowserMode from "../../../hooks/useBrowserMode"
import useHomeLinkMode from "../../../hooks/useHomeLinkMode"
import useLocaleMode from "../../../hooks/useLocaleMode"
import fbIcon from "./../../../assets/images/facebook-logo.svg"
import igIcon from "./../../../assets/images/instagram-logo.svg"
import ytIcon from "./../../../assets/images/youtube-logo.svg"
import celularIconWhite from "./../../../assets/images/icon-celular-white.svg"
import logoFamilia from "./../../../assets/images/logo-grupo-familia.svg"
import logoDescreet from "./../../../assets/images/logo-discreet.svg"
import LightBox from "./../../organisms/lightbox/lightbox"
import "./footer.scss"

const Footer = props => {
  const { locale } = useLocaleMode()
  const { homeLink } = useHomeLinkMode()
  const { isBrowser } = useBrowserMode()
  const node = React.useRef()
  const lightBoxUsage = "countriesList"
  const [listOpen, setCountriesState] = React.useState(false)
  const [fCloseClass, setClass] = React.useState("")

  const currentFlag = props.countriesData.filter(
    country => country.titulo.toUpperCase() === process.env.COUNTRY_NAME
  )[0].bandera

  const openHideDropdown = () => {
    if (listOpen === false) {
      setCountriesState(true)
    } else {
      setClass("f-closed-dropdown")
      setTimeout(() => {
        setCountriesState(false)
        setClass("")
      }, 200)
    }
  }

  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      return
    }
    setClass("f-closed-dropdown")
    setTimeout(() => {
      setCountriesState(false)
      setClass("")
    }, 500)
  }

  // React.useEffect(() => {
  //   if (listOpen) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [listOpen]);

  const result = useStaticQuery(graphql`
    query InfoFooter {
      allContentfulTenaHome {
        nodes {
          footerInformacionAdicionalDos
          footerInformacionAdicionalTres
          footerInformacionAdicionalUno
          footerInformacionAdicionalCuatro
          footerNumeroLineaDeAtencion
          footerRedireccionDos
          footerRedireccionTres
          footerRedireccionCuatro
          footerTituloLineaDeAtencion
          footerRedireccionUno
          footerLineaDeAtencionRegistro
          footerBrandLogo {
            file {
              url
            }
            title
          }
          node_locale
          tieneInstagram
        }
      }
    }
  `)

  const footerInfo =
    result &&
    isBrowser &&
    result.allContentfulTenaHome.nodes.filter(
      node => node.node_locale === locale
    )[0]

  const {
    footerTituloLineaDeAtencion,
    footerNumeroLineaDeAtencion,
    footerInformacionAdicionalUno,
    footerInformacionAdicionalDos,
    footerInformacionAdicionalTres,
    footerInformacionAdicionalCuatro,
    footerRedireccionDos,
    footerRedireccionTres,
    footerRedireccionCuatro,
    footerRedireccionUno,
    footerLineaDeAtencionRegistro,
    footerBrandLogo,
    tieneInstagram
  } = footerInfo

  return (
    <>
      {listOpen && (
        <LightBox
          openHideDropdown={openHideDropdown}
          classToAdd={fCloseClass}
          lightBoxUsage={lightBoxUsage}
          countriesData={props.countriesData}
        />
      )}
      {footerInfo && (
        <footer
          className={
            `f-footer-wrapper ${
              props.isFullPage ? "f-footer-wrapper--fullpage" : ""
            }` + (props.isDescreet ? " f-descreet" : "")
          }
        >
          {props.isFullPage ? (
            <div className="f-footer-info-container">
              <div className="f-phone-info-wrapper">
                {locale !== "es-BO" ? (
                  <>
                    <img
                      src={celularIconWhite}
                      alt="imagen de linea de atencion"
                    />
                    <div>
                      <p>
                        {props.isMobile
                          ? footerTituloLineaDeAtencion
                          : footerLineaDeAtencionRegistro}
                      </p>
                      <a
                        href={`tel://${footerNumeroLineaDeAtencion}`}
                        className="f-btn-nav-type"
                        rel="nofollow"
                      >
                        {footerNumeroLineaDeAtencion}
                      </a>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          ) : (
            <>
              <div className="f-footer-info-container">
                <div className="f-phone-countries">
                  {props.isDescreet ? (
                    <a
                      className="f-select-container"
                      href={homeLink + "discreet/"}
                    >
                      <img
                        src={logoDescreet}
                        alt="logo descreet"
                        className="f-logo-descreet"
                      />
                    </a>
                  ) : (
                    <div className="f-select-container">
                      <span
                        onClick={openHideDropdown}
                        className={
                          listOpen
                            ? "f-select-title f-select-title--active"
                            : "f-select-title"
                        }
                      >
                        <Img
                          className="f-image-flag"
                          fluid={currentFlag.fluid}
                          alt={currentFlag.description}
                        />
                        <label htmlFor="">{process.env.COUNTRY_NAME}</label>
                      </span>
                    </div>
                  )}
                  <div className="f-phone-info-wrapper">
                    {locale !== "es-BO" ? (
                      <>
                        <img
                          src={celularIconWhite}
                          alt="imagen de linea de atencion"
                        />
                        <div>
                          <p>{footerTituloLineaDeAtencion}</p>
                          <a
                            href={`tel://${footerNumeroLineaDeAtencion}`}
                            className="f-btn-nav-type"
                            rel="nofollow"
                          >
                            {footerNumeroLineaDeAtencion}
                          </a>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="f-social">
                  <a
                    target="_blank"
                    href={
                      props.isDescreet
                        ? "https://www.facebook.com/masvivasquenunca"
                        : "https://www.facebook.com/TenaBienEstar"
                    }
                  >
                    <img src={fbIcon} alt="icono facebook" />
                  </a>
                  {
                    tieneInstagram &&
                      <a
                        target="_blank"
                        href={
                          props.isDescreet
                            ? "https://instagram.com/masvivas?igshid=1u5l2xtzxto42"
                            : "https://www.instagram.com/masvivas/"
                        }
                      >
                        <img src={igIcon} alt="icono instagram" />
                      </a>
                  }                   
                  <a
                    target="_blank"
                    href={
                      props.isDescreet
                        ? "https://www.youtube.com/channel/UCIDfwvhgDLjd9uPrXi6sW_w"
                        : "https://www.youtube.com/channel/UC0HCMvbKjfj0cnpEalVlG2w"
                    }
                  >
                    <img src={ytIcon} alt="icono Youtube" />
                  </a>
                </div>
              </div>
              <div className="f-brand-logo">
                {footerInfo && (
                  <ul className="f-additional-pages">
                    <li>
                      <a
                        className="f-footer-nav-link"
                        title={footerInformacionAdicionalUno}
                        href={homeLink + footerRedireccionUno}
                      >
                        {footerInformacionAdicionalUno} |
                      </a>
                    </li>
                    <li>
                      <a
                        className="f-footer-nav-link"
                        title={footerInformacionAdicionalDos}
                        href={homeLink + footerRedireccionDos}
                      >
                        {footerInformacionAdicionalDos +
                          (!props.isMobile ? " | " : "")}
                      </a>
                    </li>
                    <li>
                      <a
                        className="f-footer-nav-link"
                        title={footerInformacionAdicionalTres}
                        href={homeLink + footerRedireccionTres}
                      >
                        {footerInformacionAdicionalTres +
                          (!props.isMobile ? " | " : "")}
                      </a>
                    </li>
                    <li>
                      <a
                        className="f-footer-nav-link"
                        title={footerInformacionAdicionalCuatro}
                        href={homeLink + footerRedireccionCuatro}
                      >
                        {footerInformacionAdicionalCuatro}
                      </a>
                    </li>
                  </ul>
                )}
                <div className="f-brand-container">
                  <img
                    src={footerBrandLogo.file.url}
                    alt={footerBrandLogo.title}
                  />
                  <small>© 2020 Todos los derechos reservados</small>
                </div>
              </div>
            </>
          )}
        </footer>
      )}
    </>
  )
}

export default Footer
